import i18n from '@/vendors/i18n'
import EmailRule from '@/classes/email_rules/EmailRule'

export default class Email {
  constructor ({ id = null, content = i18n.getLocalesTranslations(), subject = i18n.getLocalesTranslations(), is_enabled = false, email_type = {}, email_rule } = {}) {
    this.id = id
    this.content = content
    this.subject = subject
    this.is_enabled = is_enabled
    this.email_type = email_type
    this.email_rule = new EmailRule(email_rule || {})
  }
}
